"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateActiveQuestions = void 0;
const FormQuestionType_1 = __importDefault(require("../FormQuestionType"));
const getSelectedOptionsForAnswer_1 = __importDefault(require("./getSelectedOptionsForAnswer"));
const updateActiveQuestions = (form, questionNode
// eslint-disable-next-line max-params
) => {
    var _a, _b;
    if (!questionNode)
        questionNode = form.questionTree;
    if (questionNode.root) {
        questionNode.enabled = true;
        (_a = questionNode.subQuestions) === null || _a === void 0 ? void 0 : _a.forEach(x => {
            x.enabled = true;
            (0, exports.updateActiveQuestions)(form, x);
        });
    }
    else if (questionNode.enabled) {
        const q = form.questions[questionNode.nodeId];
        let subquestions;
        switch (q.type) {
            case FormQuestionType_1.default.REPETITION:
            case FormQuestionType_1.default.QUESTIONSET:
            case FormQuestionType_1.default.SECTION:
                const rule = form.rules[q.questionId];
                subquestions = getSubquestions(q.type, rule, form.questions);
                break;
            default:
                const a = form.answers[questionNode.nodeId] || {};
                subquestions = getSubquestions(q.type, form.rules[q.questionId], a);
        }
        for (let i = 0; i < ((_b = questionNode.subQuestions) === null || _b === void 0 ? void 0 : _b.length); i++) {
            const x = questionNode.subQuestions[i];
            x.enabled = subquestions.some(z => x.questionId === z);
            (0, exports.updateActiveQuestions)(form, x);
        }
    }
};
exports.updateActiveQuestions = updateActiveQuestions;
exports.default = exports.updateActiveQuestions;
const getSubquestions = (questionType, rule, answer) => {
    var _a, _b;
    switch (questionType) {
        case FormQuestionType_1.default.REPETITION:
        case FormQuestionType_1.default.SECTION:
        case FormQuestionType_1.default.QUESTIONSET: {
            return ((_a = rule.questions) !== null && _a !== void 0 ? _a : []);
        }
        case FormQuestionType_1.default.RATING:
        case FormQuestionType_1.default.NUMBER:
        case FormQuestionType_1.default.LIST:
        case FormQuestionType_1.default.CHECK: {
            const options = (0, getSelectedOptionsForAnswer_1.default)(questionType, rule, answer);
            return (_b = options === null || options === void 0 ? void 0 : options.reduce((acc, z) => acc.concat(z.subQuestions), [])) !== null && _b !== void 0 ? _b : [];
        }
        default:
            return [];
    }
};
